import type { AdminState } from './types'

export const selectAdmin = (state: { admin: AdminState }) => state.admin
